import React, { createContext, useContext, useState, useCallback, useRef } from "react";

const EventContext = createContext();

export const Allcontext = ({ children }) => {
  const [carCount, setCarCount] = useState(false);
  const [titleCount, setTitleCount] = useState(false);
  const [sellerChatList, setSellerChatList] = useState([]);
  const [webData, setWebData] = useState(null);
  const [recentlyAddedCars, setRecentlyAddedCars] = useState([]);
  const [allCars, setAllCars] = useState([]);
  const [recentlySoldCars, setRecentlySoldCars] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [carDetailsData, setCarDetailsData] = useState(null);
  const [proxyBidData, setProxyBidData] = useState(null);
  const [sellerPrivilegesData, setSellerPrivilegesData] = useState(null);
  const [feeDetailsData, setFeeDetailsData] = useState(null);
  // Use a ref to track timeout for clearing webData
  const webDataTimeoutRef = useRef(null);
  const handleCarCount = () => {
    setCarCount(true);
  };

  const handleTitleCount = () => {
    setTitleCount(true);
  };

  const handleWebData = useCallback((data) => {
    console.log("handleWebData received:", data);

    // Clear any existing timeout
    if (webDataTimeoutRef.current) {
      clearTimeout(webDataTimeoutRef.current);
    }

    // Set the webData
    setWebData(data);

    // Check if this is a counter_bid response (success/error)
    let isCounterBidResponse = false;

    if (Array.isArray(data) && data.length > 0 && data[0] && data[0].success !== undefined) {
      isCounterBidResponse = true;
      console.log("Counter bid response detected:", data);
    } else if (data && data.success !== undefined) {
      isCounterBidResponse = true;
      console.log("Counter bid response detected (object):", data);
    }

    // For counter bid responses, keep webData longer (15 seconds)
    // For other messages, clear after 500ms
    const clearDelay = isCounterBidResponse ? 15000 : 500;

    webDataTimeoutRef.current = setTimeout(() => {
      console.log("Clearing webData after", clearDelay, "ms");
      setWebData(null);
      webDataTimeoutRef.current = null;
    }, clearDelay);

    // Process other data types
    // inside handleWebData, replace the array-handling block:
    if (Array.isArray(data)) {
      const lastElem = data[data.length - 1];

      if (data.length >= 2 && typeof lastElem === 'string') {
        const messageType = lastElem;
        const messageParts = data.slice(0, -1); // everything except the model name

        switch (messageType) {
          case "recentlyAddCarsfilter":
            if (Array.isArray(messageParts[0])) setRecentlyAddedCars(messageParts[0]);
            break;

          case "allCarsfilter":
            if (Array.isArray(messageParts[0])) setAllCars(messageParts[0]);
            break;

          case "recentlysoldcarsfilter":
            if (Array.isArray(messageParts[0])) setRecentlySoldCars(messageParts[0]);
            break;

          case "notificationDetails":
            if (Array.isArray(messageParts[0])) setNotifications(messageParts[0]);
            break;

          case "carDetails":
            // messageParts = [data, data1] — same shape as the REST response
            setCarDetailsData({ data: messageParts[0], data1: messageParts[1] });
            break;

          case "proxybidDetails":
            if (Array.isArray(messageParts[0])) setProxyBidData(messageParts[0]);
            break;

          case "sellerPrivileges":
            if (Array.isArray(messageParts[0])) setSellerPrivilegesData(messageParts[0]);
            break;

          case "fees":
            if (Array.isArray(messageParts[0])) setFeeDetailsData(messageParts[0]);
            break;

          case "counter_bid":
            console.log("Counter bid response:", messageParts[0]);
            break;

          case "chat":
            if (Array.isArray(messageParts[0])) setSellerChatList(messageParts[0]);
            else if (messageParts[0] && typeof messageParts[0] === 'object') setSellerChatList([messageParts[0]]);
            break;

          default:
            console.log("Unknown message type:", messageType);
            break;
        }
      }
      else if (data.length >= 1 && data[0] && data[0].success !== undefined) {
        console.log("Simple success/error response:", data);
      }
      else if (data.length > 0 && data[0] && (data[0].message !== undefined || data[0].chat_id !== undefined)) {
        setSellerChatList(data);
      }
    }
    else if (data && typeof data === 'object') {
      if (data.model === "counter_bid") {
        console.log("Counter bid response (object format):", data);
      } else if (data.model === "chat") {
        console.log("Chat message (object format):", data);
        if (data.data && Array.isArray(data.data)) {
          setSellerChatList(data.data);
        }
      }
    }
  }, []);

  // Cleanup timeout on unmount
  React.useEffect(() => {
    return () => {
      if (webDataTimeoutRef.current) {
        clearTimeout(webDataTimeoutRef.current);
      }
    };
  }, []);

  return (
    <EventContext.Provider
      value={{
        handleCarCount,
        carCount,
        handleTitleCount,
        titleCount,
        handleWebData,
        webData,
        sellerChatList,
        recentlyAddedCars,
        allCars,
        recentlySoldCars,
        notifications,
        carDetailsData,
        proxyBidData,
        sellerPrivilegesData,
        feeDetailsData,
      }}
    >
      {children}
    </EventContext.Provider>
  );
};

export const CountContext = EventContext;